import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PlatformService } from '../platform/platform.service';
@Injectable({ providedIn: 'root' })
export class GuardGuard implements CanActivate, CanActivateChild {
  constructor(
    private platform: PlatformService,
    private router: Router
  ) {}
  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      await this.platform.refresh();
      const url = state.url;
      if (url.startsWith('/administracao') && !this.platform.canManagePlatform) return this.router.parseUrl('/acesso-negado');
      const required = url.startsWith('/sogesp')
        ? ['sogesp', 'project.metrics.read']
        : url.startsWith('/game-cardio-admin')
          ? ['game-cardio', 'project.metrics.read']
        : url.startsWith('/waf-access-blocks')
          ? ['shared-services', 'waf.read']
          : /^\/(comunicacoes|lotes-mensagens)/.test(url)
            ? ['shared-services', 'communications.read']
            : null;
      if (required) {
        if (!this.platform.has(required[0], required[1])) return this.router.parseUrl('/acesso-negado');
        this.platform.selected = required[0];
        this.platform.navigation();
      }
      return true;
    } catch {
      return this.router.parseUrl('/login');
    }
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
}
